module.exports = __webpack_public_path__ + "img/ru_badge_web_generic.14df6f33.png";